import Vue from "vue";
const api_path = "/relatorios/vendas-por-forma-de-pagamento";

export async function index(options, advanced_filters = {}) {
  const { sortBy, sortDesc, page, itemsPerPage } = options;

  const response = await Vue.prototype.$http.get(api_path, {
    params: {
      orderBy: sortBy[0] ? sortBy[0] : "",
      sortDesc: sortDesc[0] ? sortDesc[0] : "",
      page,
      perPage: itemsPerPage,
      ...advanced_filters
    }
  });

  return response.data;
}
